import { UpdateMeLocaleRequestConfig, useStorytellClient } from "@storytell/client";
import { createEffect } from "solid-js";
import { isServer } from "solid-js/web";
import { useI18n } from "~/i18n/context";
import { useWire } from "~/wire";
import { authTokenReady } from "~/wire/authTokenReady";

const STORAGE_KEY = "user-locale-sync";

/** Scheduled email reads the timezone and language stored on the user to land at 9am local time in that language. */
export function useSyncUserLocale() {
  const wire = useWire();
  const client = useStorytellClient();
  const { currentLanguage } = useI18n();

  createEffect(() => {
    if (isServer || !authTokenReady(wire.auth) || wire.auth.isGuest()) return;
    const userId = wire.auth.userId();
    if (!userId) return;

    const body = { timezone: Intl.DateTimeFormat().resolvedOptions().timeZone, locale: currentLanguage() };
    const marker = JSON.stringify({ userId, ...body });
    try {
      if (localStorage.getItem(STORAGE_KEY) === marker) return;
    } catch {
      // Blocked site data sends on every load instead.
    }

    const send = async () => {
      const res = await client.fetch(UpdateMeLocaleRequestConfig.withBearerToken(wire.auth.token()), undefined, body);
      if (res.isErr()) return;
      try {
        localStorage.setItem(STORAGE_KEY, marker);
      } catch {
        /* blocked site data: see above */
      }
    };
    void send();
  });
}
